export default __webpack_public_path__ + "media/zurb/img/about/talent/talent-img1-769d7071b24bf14be8197839339cb867.png";